'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = onBackspace;

var _constants = require('./constants');

var _utils = require('./utils');

/**
 * Sticky Backspace Link logic
 *
 * @param {Event} event
 * @param {Editor} editor
 * @param {function} next
 * @param {Objects} opts
 * @return {Null | Change}
 */

function onBackspace(event, editor, next, opts) {
  var canBeEmpty = opts.canBeEmpty,
      stickOnDelete = opts.stickOnDelete;
  var _editor$value = editor.value,
      document = _editor$value.document,
      selection = _editor$value.selection,
      focusInline = _editor$value.focusInline;

  if (selection.isExpanded) return next();

  // Logic for backspacing "into" a sticky inline
  var isAtStartOfCurrentTextNode = !focusInline && editor.value.selection.focus.offset === 0;

  if (isAtStartOfCurrentTextNode && stickOnDelete) {
    var upcomingNode = document.getPreviousSibling(selection.focus.path);
    if ((0, _utils.isInlineBanned)(editor, upcomingNode, opts)) return next();

    event.preventDefault();
    return editor.moveToEndOfNode(upcomingNode).deleteBackward();
  }

  // Logic for deleting inside the sticky inline
  if (!focusInline || !canBeEmpty) return next();
  if (focusInline.text.length === 1 && focusInline.text === _constants.ZERO_WIDTH_SPACE) return next();

  if (focusInline.text.length !== 1) return next();
  event.preventDefault();
  return editor.insertText(_constants.ZERO_WIDTH_SPACE).moveBackward(1).deleteBackward().moveForward(1);
}